document.documentElement.classList.add('alovvilo-js');
document.addEventListener('shopify:section:load',()=>document.documentElement.classList.add('alovvilo-editor-ready'));

function initAlovviloFaq(root = document) {
  root.querySelectorAll('.alovvilo-faq__details').forEach((details) => {
    if (details.dataset.alovviloReady) return;
    details.dataset.alovviloReady = 'true';
    details.addEventListener('toggle', () => {
      const summary = details.querySelector('summary');
      if (summary) summary.setAttribute('aria-expanded', String(details.open));
      if (!details.open) return;
      details.closest('.alovvilo-faq__list')?.querySelectorAll('.alovvilo-faq__details[open]').forEach((item) => {
        if (item !== details) item.removeAttribute('open');
      });
    });
  });
}

initAlovviloFaq();
document.addEventListener('shopify:section:load', (event) => initAlovviloFaq(event.target));

function updateAlovviloCardVariant(button) {
  const card = button.closest('.card-wrapper');
  const purchase = button.closest('[data-alovvilo-card-purchase]');
  if (!card || !purchase || button.disabled) return;

  purchase.querySelectorAll('[data-alovvilo-card-variant]').forEach((item) => {
    const selected = item === button;
    item.classList.toggle('is-selected', selected);
    item.setAttribute('aria-pressed', String(selected));
  });

  const variantInput = purchase.querySelector('.product-variant-id');
  if (variantInput) {
    variantInput.value = button.dataset.variantId;
    variantInput.disabled = false;
    variantInput.dispatchEvent(new Event('change', { bubbles: true }));
  }

  const buyNow = purchase.querySelector('[data-alovvilo-buy-now]');
  if (buyNow) {
    buyNow.href = buyNow.href.replace(/\/\d+:1(?:\?checkout)?$/, `/${button.dataset.variantId}:1?checkout`);
    buyNow.removeAttribute('aria-disabled');
    buyNow.removeAttribute('tabindex');
  }

  if (button.dataset.variantImage) {
    const image = card.querySelector('.card__media .media img');
    if (image) {
      image.src = button.dataset.variantImage;
      image.removeAttribute('srcset');
      image.alt = button.dataset.variantAlt || image.alt;
    }
  }

  const price = card.querySelector('.card-information .price');
  if (price && button.dataset.variantPrice) {
    const comparePrice = button.dataset.variantComparePrice;
    price.classList.toggle('price--on-sale', Boolean(comparePrice));
    const regularPrice = price.querySelector('.price__regular .price-item--regular');
    const salePrice = price.querySelector('.price__sale .price-item--sale');
    const comparePriceNode = price.querySelector('.price__sale .price-item--regular');
    if (regularPrice) regularPrice.textContent = button.dataset.variantPrice;
    if (salePrice) salePrice.textContent = button.dataset.variantPrice;
    if (comparePriceNode && comparePrice) comparePriceNode.textContent = comparePrice;
  }
}

document.addEventListener('click', (event) => {
  const variantButton = event.target.closest('[data-alovvilo-card-variant]');
  if (variantButton) updateAlovviloCardVariant(variantButton);
});
